import { FilterTypes } from './filter-types.enum';

export interface FiltersList {
  [key: string]: any;
  selector: string;
  title: string;
  type: FilterTypes;
  showInDropdown?: boolean;
  showCountInHierarchy?: boolean;
  nodeSelectType?: string;
  data?: any[];
}
